import React from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as AutoBatchName} from 'assets/svg/auto-batch-name.svg';
import {Icon} from 'components/ui-kit/Icon';
import {colors} from 'theme';

import {Root, IconSection, TextSection, Description, Title} from './styled';

export const BatchAutoBanner = () => {
    const {t} = useTranslation();
    return (
        <Root>
            <IconSection>
                <Icon
                    source={AutoBatchName}
                    width={16}
                    height={16}
                    fillColor="transparent"
                    strokeColor={colors.brandPrimary}
                />
            </IconSection>
            <TextSection>
                <Description>
                    {t('pages.documents.details.Utilization.batchNumberAuto')}
                </Description>
                <Title>{t('pages.documents.details.Utilization.batchNumberAutoDescription')}</Title>
            </TextSection>
        </Root>
    );
};
